import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Ar from './Ar';

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <Ar />
);
